import React from 'react';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  return (
    <>
      {/* Add shooting star animation styles */}
      <style>{`
        @keyframes shoot {
          0% { transform: translateX(300px) translateY(-300px) rotate(45deg); opacity: 0; }
          5% { opacity: 1; }
          15% { transform: translateX(-600px) translateY(600px) rotate(45deg); opacity: 0; }
          100% { transform: translateX(-600px) translateY(600px) rotate(45deg); opacity: 0; }
        }
        .shooting-star {
          animation: shoot 8s cubic-bezier(0.4, 0, 0.2, 1) infinite;
        }
        .text-shadow-glow {
          text-shadow: 0 0 25px rgba(255,255,255,0.4);
        }
        .moon {
          background: radial-gradient(circle at 30% 30%, #e8e8e8 0%, #c0c0c0 30%, #808080 60%, #404040 100%);
          box-shadow: 
            inset -20px -20px 40px rgba(0,0,0,0.4),
            0 0 80px rgba(255,255,255,0.2),
            0 0 120px rgba(255,255,255,0.1);
        }
      `}</style>

      <section id="hero" className="relative h-screen flex flex-col justify-center items-center px-6 overflow-hidden">
        <div className="absolute inset-0 z-0">
          {/* Removed blur effects */}
        </div>

        {/* CSS Moon in background - GUARANTEED TO SHOW */}
        <div className="absolute inset-0 z-[1] flex items-center justify-center pointer-events-none">
          <div 
            className="moon w-[400px] h-[400px] md:w-[600px] md:h-[600px] rounded-full opacity-30 animate-pulse" 
            style={{ animationDuration: '12s' }}
          ></div>
        </div>

        {/* Shooting stars */}
        <div className="absolute top-[15%] right-[15%] w-[200px] h-[1px] bg-gradient-to-l from-transparent via-white/80 to-transparent opacity-0 shooting-star pointer-events-none z-10"></div>
        <div 
          className="absolute top-[25%] right-[25%] w-[150px] h-[1px] bg-gradient-to-l from-transparent via-white/60 to-transparent opacity-0 shooting-star pointer-events-none z-10"
          style={{ animationDelay: '3s' }}
        ></div>
        <div 
          className="absolute top-[35%] right-[5%] w-[180px] h-[1px] bg-gradient-to-l from-transparent via-white/70 to-transparent opacity-0 shooting-star pointer-events-none z-10"
          style={{ animationDelay: '6s' }}
        ></div>

        <div className="relative z-20 text-center max-w-4xl mx-auto">
          <p className="text-zinc-500 tracking-[0.3em] uppercase mb-6 text-sm md:text-base animate-fadeIn"></p>
          <h1 className="text-5xl md:text-7xl lg:text-9xl font-bold text-white tracking-tighter leading-none text-shadow-glow">
            MANIFEST
            <span className="block text-4xl md:text-6xl lg:text-7xl font-extralight text-zinc-300 mt-2 tracking-[0.2em]">ENTERTAINMENT</span>
          </h1>
          <p className="text-lg md:text-xl text-zinc-400 max-w-2xl mx-auto leading-relaxed font-light tracking-wide mb-12 mt-8">
            Curating the extraordinary. We bridge the gap between vision and reality through premiere celebrity management and high-end event production.
          </p>
          <div className="flex flex-col md:flex-row items-center justify-center gap-6">
            <button 
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 bg-white text-black font-medium text-sm tracking-widest uppercase hover:bg-zinc-200 transition-colors duration-300 min-w-[160px]"
            >
              Get in Touch
            </button>
            <button 
              onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 border border-zinc-700 text-white font-medium text-sm tracking-widest uppercase hover:bg-zinc-900 transition-colors duration-300 min-w-[160px]"
            >
              Explore
            </button>
          </div>
        </div>

        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce text-zinc-600 z-20">
          <ChevronDown size={24} />
        </div>
      </section>
    </>
  );
};

export default Hero;